module.exports = __webpack_public_path__ + "static/media/2.33ad85d8.jpg";